import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ApprovalResource } from './ApprovalResource';
import { CycleValidationSnapshot } from './CycleValidationSnapshot';
import { CycleValidationApproval } from './CycleValidationApproval';
import { CycleValidationPostingFile } from './CycleValidationPostingFile';

export class SnapshotApprovalResource extends FBaseService implements ApprovalResource {
  public async getApproval(fiId: string, snapshotId: number): Promise<CycleValidationApproval> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/director/${fiId}/cycle-validation-approval/SNAPSHOT/${snapshotId}`);

    const result: CycleValidationApproval = response.data.data;
    return result;
  }

  public async saveApproval(fiId: string, snapshot: CycleValidationSnapshot, approvalStatus: string, files: CycleValidationPostingFile[] | undefined): Promise<CycleValidationSnapshot> {
    const toSave = { ...snapshot };
    toSave.approvalState = approvalStatus;
    const response: AxiosResponse = await this.apiClient.put(`/api/rcx/director/${fiId}/cycle-validation-snapshot/${toSave.id}`, toSave);
    const result: CycleValidationSnapshot = response.data.data;
    return result;
  }
}

export default SnapshotApprovalResource;
